import {
  ChangePassword,
  ChangePasswordFailure,
  ChangePasswordPayload,
  ChangePasswordSuccess,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_SUCCESS,
  EmailSignIn,
  EmailSignInPayload,
  EmailSignUp,
  EmailSignUpPayload,
  EMAIL_SIGN_IN,
  EMAIL_SIGN_UP,
  GoogleSignIn,
  GoogleSignInPayload,
  GOOGLE_SIGN_IN,
  RefreshTokenFailure,
  RefreshTokenSuccess,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  RestoreAuthFailure,
  RestoreAuthFromStorage,
  RestoreAuthSuccess,
  RESTORE_AUTH_FAILURE,
  RESTORE_AUTH_FROM_STORAGE,
  RESTORE_AUTH_SUCCESS,
  SetAuthError,
  SET_AUTH_ERROR,
  SignInFailure,
  SignInSuccess,
  SignOut,
  SignOutFailure,
  SignOutSuccess,
  SignUpFailure,
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_OUT,
  SIGN_OUT_FAILURE,
  SIGN_OUT_SUCCESS,
  SIGN_UP_FAILURE,
  VerifyToken,
  VerifyTokenFailure,
  VerifyTokenPayload,
  VerifyTokenSuccess,
  VERIFY_TOKEN,
  VERIFY_TOKEN_FAILURE,
  VERIFY_TOKEN_SUCCESS,
} from './authentication.action.type';

export const googleSignIn = (payload: GoogleSignInPayload): GoogleSignIn => ({
  type: GOOGLE_SIGN_IN,
  payload,
});

export const emailSignIn = (payload: EmailSignInPayload): EmailSignIn => ({
  type: EMAIL_SIGN_IN,
  payload,
});

export const signInSuccess = (token: string): SignInSuccess => ({
  type: SIGN_IN_SUCCESS,
  payload: { token },
});

export const signInFailure = (error: string): SignInFailure => ({
  type: SIGN_IN_FAILURE,
  payload: error,
});

export const emailSignUp = (payload: EmailSignUpPayload): EmailSignUp => ({
  type: EMAIL_SIGN_UP,
  payload,
});

export const signUpFailure = (error: string): SignUpFailure => ({
  type: SIGN_UP_FAILURE,
  payload: error,
});

export const signOut = (): SignOut => ({
  type: SIGN_OUT,
  payload: undefined,
});

export const signOutSuccess = (): SignOutSuccess => ({
  type: SIGN_OUT_SUCCESS,
  payload: undefined,
});

export const signOutFailure = (error: string): SignOutFailure => ({
  type: SIGN_OUT_FAILURE,
  payload: error,
});

export const verifyToken = (payload: VerifyTokenPayload): VerifyToken => ({
  type: VERIFY_TOKEN,
  payload,
});

export const verifyTokenSuccess = (): VerifyTokenSuccess => ({
  type: VERIFY_TOKEN_SUCCESS,
  payload: undefined,
});

export const verifyTokenFailure = (error: string): VerifyTokenFailure => ({
  type: VERIFY_TOKEN_FAILURE,
  payload: error,
});

export const refreshTokenSuccess = (token: string): RefreshTokenSuccess => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload: token,
});

export const refreshTokenFailure = (error: string): RefreshTokenFailure => ({
  type: REFRESH_TOKEN_FAILURE,
  payload: error,
});

export const setAuthError = (error: string): SetAuthError => ({
  type: SET_AUTH_ERROR,
  payload: error,
});

export const changePassword = (
  payload: ChangePasswordPayload,
): ChangePassword => ({
  type: CHANGE_PASSWORD,
  payload,
});

export const changePasswordSuccess = (
  token: string,
): ChangePasswordSuccess => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: token,
});

export const changePasswordFailure = (
  error: string,
): ChangePasswordFailure => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error,
});

export const restoreAuthFromStorage = (): RestoreAuthFromStorage => ({
  type: RESTORE_AUTH_FROM_STORAGE,
  payload: undefined,
});

export const restoreAuthSuccess = (token: string): RestoreAuthSuccess => ({
  type: RESTORE_AUTH_SUCCESS,
  payload: { token },
});

export const restoreAuthFailure = (error: string): RestoreAuthFailure => ({
  type: RESTORE_AUTH_FAILURE,
  payload: error,
});
